import { NgModule } from '@angular/core';
import { NotificationComponent } from './notification.component';
import { ViewNotificationComponent } from './notification/view-notification/view-notification.component';
import { BrowserModule } from '@angular/platform-browser';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import {MatTabsModule} from '@angular/material/tabs';
import { Ng2SearchPipeModule } from 'ng2-search-filter';

@NgModule({
  declarations: [
    NotificationComponent,
    ViewNotificationComponent
  ],
  imports: [
    BrowserModule,MatTabsModule,MatCardModule,MatDividerModule,MatButtonModule,MatListModule,
    FormsModule,TranslateModule,MatIconModule,MatBadgeModule,
    ReactiveFormsModule,HttpClientModule,RouterModule,Ng2SearchPipeModule
  ],
  exports: [
    NotificationComponent, ViewNotificationComponent
  ]
})
export class NotificationModule { }
